<template>
  <div class="content Tabs">

    <b-tabs card>

      <b-tab :title="lang.tab_General" :title-link-class="textColors" :title-item-class="textColors"
        :active="true">

        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_1">
          <b-card-text>
            support@flowcad.com
            <br><br>
            {{lang.infotext_1}}
            <br>
            <a href="https://www.flowcad.com/en/support.htm" target="_blank">Support</a>
            <br><br>
          </b-card-text>


        </b-card>
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_2">
          <b-card-text>


            <a href="https://www.flowcad.com/microsite/index.htm?passcode=2a715289-d786-40ba-beaa-5494cd9b7023"
              target="_blank">{{lang.infotext_2}}</a>
            <br><br>

          </b-card-text>


        </b-card>
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_3">
          <b-card-text>
            <p>{{lang.label_build1}}: {{ buildObject.build}}</p>
            <p>{{lang.label_build2}}: {{agentBuild}}<span v-if="!isAgent"> ({{ lang.label_isAgent_tooltip }})</span></p>

            <p v-if="buildObject.buildAgentUpdate!=null">{{lang.label_build3}}: {{ buildObject.buildAgentUpdate }}</p>
            <br>
            <br>
            <p>{{lang.label_build4}}: <a href="#" @click="getAgentUpdate">Omnya Agent</a></p>
            <span v-if="isError" id="link-agent-feedback" class="red">
              {{ lang.label_build4_feedback }}
            </span>
          </b-card-text>


        </b-card>
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_4">
          <b-card-text>
            <p>{{ lang.label_license1 }}:
              <span v-if="(expiresDays == 0 | expiresDays == 1 ) && expiresDays != null">{{ expiresDays }} {{
                lang.label_license2 }}</span>
              <span v-if="expiresDays > 1">{{ expiresDays }} {{ lang.label_license3 }}</span>
              <span v-if="expiresDays < 0 || expiresDays == null">{{ lang.label_license4 }}</span>

            </p>
            <p>{{ lang.label_licenseUsers }}:

              <span>{{ maxUsers }}</span>

            </p>

          </b-card-text>


        </b-card>
        <b-card v-if="globalSettings.SEDetails" class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_5">
          <b-card-text v-if="statusSEInfo == 'OK'">
            <p>{{ lang.label_SE_tokens }}: {{ SEInfo.PartDetailCount }}/{{ SEInfo.PartDetailLimit }}</p>
            
            <p>{{ lang.label_SE_expiration }}: {{ SEInfo.ExpirationDate }}</p>
            
          </b-card-text>
          <b-card-text v-if="statusSEInfo == 'ERROR'">
            <p>{{ SEInfoMessage }}</p>
          </b-card-text>

        </b-card>



      </b-tab>


    </b-tabs>



  </div>

</template>
<script>



import { mapGetters } from 'vuex'
import TooltipIcon from '@/components/shared/TooltipIcon.vue'

export default {
  name: "Content",
  components: {
    TooltipIcon

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      selectedTheme: this.$store.getters.s_skinVariant,
      themes: [
        { item: 'dark', name: 'Dark' },
        { item: 'light', name: 'Light' },

      ],
      selectedLanguage: this.$store.getters.langVariant,
      languages: [
        { item: 'en', name: 'English' },

      ],
      
      
      agentBuild: "",
      isError: false,
      buildObject: {
        build: "",
        buildAgentUpdate: ""
      },
      SEInfo: {
        "CreationDate": "",
        "ExpirationDate": "",
        "PartDetailLimit": "0",
        "PartDetailCount": "0",
        "PartDetailRemaining": "0",
        "AclPartsCount": "0"
      },
      statusSEInfo: null,
      SEInfoMessage: null,
    }
  },
  computed: {
    ...mapGetters([
      'appConf',
      'isPlugin',
      'currentUser',
      'isAgent',
      'globalSettings'
    ]),
    
    colors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    cardColorsBg(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "dark";
      }else{
        return "secondary";
      }

    },
    cardColorsText(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "white";
      }else{
        return "dark"
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    expiresDays() {


      if (this.appConf.status.expires != null) {

        const now = new Date();
        const oneDay = 1000 * 60 * 60 * 24;

        const endOfDate = new Date(this.appConf.status.expires)
        const diffInTime = endOfDate.getTime() - now.getTime();
        const diffInDays = Math.round(diffInTime / oneDay);

        return diffInDays;
      }


      return null;
    },
    maxUsers() {
      return this.appConf.status.maxUsers;
    },
    needUpdate() {
      if (this.agentBuild == "unavailable") {
        return false;
      }
      let temp = this.agentBuild.split(" / ");
      
      if (this.buildObject.buildAgentUpdate == null) {
        return false;
      }
      if (temp[0] == this.buildObject.buildAgentUpdate) {
        return false;
      }
      return true;
    }

  },
  created () {
    //this.checkLink();
    this.getAgentInfo();
    this.getBuild();
    this.getSETokensInfo();
  },

  updated() {
    


  },
  watch:{
    isAgent: function () {
      this.getBuild();
      
    }
    

  },
  methods: {
    getAgentInfo() {

      let vue = this;

      this.$store.dispatch("getAgentInfo")
        .then((result) => {

          console.log(result.data)

          if (result.status == "OK") {
            vue.buildObject.build = result.data.build;
            vue.buildObject.buildAgentUpdate = result.data.buildAgentUpdate

            let obj = {
              build: result.data.build,
              buildAgentUpdate: result.data.buildAgentUpdate
            }

            vue.$store.commit('S_BUILD', obj);
          }
          
        
      }, function (reason) {
          
          console.log(reason);

      })
      
    },
    checkLink() {
      let vue = this;
      this.$store.dispatch("s_getAgentUpdate")
        .then((result) => {

          console.log(result)
          if (result.data == null) {
            vue.isError = true;
          } else {
            vue.isError = false;
          }
        })
    },
    
    getBuild(){

      let vue = this;
      if (this.isAgent){
        this.$store.dispatch("s_checkAgentVersion")
        .then((result) => {
 
          console.log(result)
          vue.agentBuild = result;

        })
        .catch((reason)=>{

          console.log("Error:", reason)
          vue.agentBuild = vue.lang.infotext_4;
        })
      }else{
        vue.agentBuild = vue.lang.infotext_4;
      }
      

    },
    getAgentUpdate() {
      this.$store.dispatch("showLoader", { visible: true, text: "download" });
      let vue = this;
      
        this.$store.dispatch("s_getAgentUpdate")
          .then((result) => {

            console.log(result)
            //if (result.data == null) {
              vue.isError = false;
            //} else {
              //vue.isError = false;
            vue.$store.dispatch("showLoader", { visible: false });
            let ver = vue.appConf.buildAgentUpdate;
            if (vue.appConf.buildAgentUpdate == null) {
                ver = "last"
            }
            let fileName = "omnya_agent_v" + ver + ".zip";
            
            var a = document.createElement("a");
            a.href = URL.createObjectURL(result);
            
            a.download = fileName;

            document.body.appendChild(a);

            a.click();
            document.body.removeChild(a);
            //}
            

          })
          .then(function () {

            vue.$store.dispatch("showLoader", { visible: false });

          })
      


    },
    getSETokensInfo() {
      let vue = this;

      this.$store.dispatch("pm_getSETokensInfo")
        .then((result) => {

          console.log(result)
          vue.statusSEInfo = result.status;
          console.log(vue.statusSEInfo)
          if (result.status == "OK") {
            
            if (result.data != null) {

              vue.SEInfo = result.data;

             
            }
          } else {
            vue.SEInfoMessage = result.message;
          }

        });

      
    }

  },

}
</script>

<style lang="scss">
  @import "@/scss/_custom.scss";



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-text{
    margin: 10px;
  }
  .panels{
    margin: 10px;
  }
  .button-save{
    margin: 10px;
  }
  .card-title {
    margin-left: 10px;
  }
  .card{
    margin-top: 5px;
  }
  .red{
    color: $redfont;
  }
</style>



// WEBPACK FOOTER //
// src/components/About/Views/Main/Middle/Content/Content.vue